import React, { useEffect, useState } from 'react';
import { Col, Row, Form } from 'antd';
import EdenredTypo from '@sharedComponent/typography';
import EdenredHeader from '@pages/main-layout/components/main-header';
import Input from '@sharedComponent/text-field';
import EdenredButton from '@sharedComponent/button';

const CompanyBranch = ({ history }) => {
	const [form] = Form.useForm();
	const [, forceUpdate] = useState();
	useEffect(() => {
		forceUpdate({});
	}, [forceUpdate]);

	const onFinish = (values) => {
		history.push({ pathname: '/company/authority' });
	};
	return (
		<>
			<EdenredHeader />
			<Row className="company-branch-name-container">
				<Col xl={24} lg={24} md={24} sm={24} xs={24} className="branch-name-header">
					<EdenredTypo>Enter Branch Name:</EdenredTypo>
				</Col>
				<Col xl={24} lg={24} md={24} sm={24} xs={24} className="branch-name-sub-header">
					<EdenredTypo>Enter the name of the company branch under the new trade license.</EdenredTypo>
				</Col>
				<Col xl={24} lg={24} md={24} sm={24} xs={24}>
					<Form form={form} onFinish={onFinish}>
						<Row className="company-branch-form">
							<Col xl={11} lg={11} md={12} sm={24} xs={24} className="branch-name-text-field">
								<Form.Item name="Branch Name">
									<Input labels="Branch Name" labelClassName="inputlabelrequired" />
								</Form.Item>
							</Col>
						</Row>
						<Col xl={8} lg={8} md={8} sm={24} xs={24} className="branch-name-button">
							<Form.Item shouldUpdate={true}>
								{() => (
									<EdenredButton
										disabled={!form.isFieldsTouched(true) || form.getFieldsError().filter(({ errors }) => errors.length).length}>
										Next
									</EdenredButton>
								)}
							</Form.Item>
						</Col>
					</Form>
				</Col>
			</Row>
		</>
	);
};

export default CompanyBranch;
